import { render, staticRenderFns } from "./UserAdminForm.vue?vue&type=template&id=deb1d354&scoped=true&"
import script from "./UserAdminForm.vue?vue&type=script&lang=js&"
export * from "./UserAdminForm.vue?vue&type=script&lang=js&"
import style0 from "./UserAdminForm.vue?vue&type=style&index=0&id=deb1d354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb1d354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VFileInput,VRow,VTextField})
